import React, { useState, useEffect } from "react";
import { Input, Form, Col, Row, Button, Upload, notification } from "antd";
import {
  PlusOutlined,
  MailFilled,
  UploadOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import ScreenOptions from "../../util/Extensions/Screens";
import config from "../../util/ApiforContext";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 12,
    },
  },
};

const EmployeeAddForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: true,
  });
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onSuccess = () => {
    form.resetFields();
    setFileList([]);
    if (props.onSuccess) props.onSuccess();
  };

  const onFinish = (values) => {
    RequestHandler.post(`/Employee`, values).then((response) => {
      setLoading(false);
      if (response.success) {
        onSuccess();
      }
    });
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  const downloadExcelTemplate = () => {
    window.open(
      `${config.apiUrl}/Employee/DownloadExcel?t=${RequestHandler.getToken()}`
    );
  };

  const downloadImportResult = (fileName) => {
    window.open(
      `${
        config.apiUrl
      }/Employee/DownloadImportResult?t=${RequestHandler.getToken()}&fileName=${fileName}`
    );
  };

  const uploadExcelProps = {
    name: "excel",
    action: `${config.apiUrl}/Employee/ImportExcel`,
    headers: {
      Authorization: "bearer " + RequestHandler.getToken(),
      ScreenOption: ScreenOptions.screen,
    },
    accept: ".xlsx",
    maxCount: 1,
    onChange(info) {
      setFileList(info.fileList);
      const { response, status } = info.file;

      if (status !== "error" && status !== "done") return;
      if (!response) return;

      const notificationType = response.success ? "success" : "error";

      notification[notificationType]({
        message: response.message,
        duration: 3,
      });
      if (!response.success) {
        downloadImportResult(info.file.response.data);
      }
      onSuccess();
    },
  };

  return (
    <Form
      {...formItemLayout}
      form={form}
      name="employeeAdd"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={24}>
          <Form.Item
            style={{ marginTop: "4%" }}
            label="Personel Adı"
            name="Name"
            rules={[
              {
                required: true,
                message: "Lütfen Personel Adı alanını boş bırakmayın.",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="E-Posta Adresi"
            name="Email"
            rules={[{ type: "email" }]}
          >
            <Input type={MailFilled} />
          </Form.Item>
          <Form.Item
            label="T.C. Kimlik No"
            name="TcNo"
            rules={[
              {
                min: 11,
                message: "TcNo 11 karakter olmalıdır.",
              },
            ]}
          >
            <Input
              type="text"
              autoComplete="off"
              onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
              maxLength="11"
              onInput={maxLengthCheck}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
            />
          </Form.Item>

          <Form.Item
            label="Cep Numarası"
            name="MobilePhone"
            rules={[
              {
                min: 12,
                message: "Telefon numarasını eksiksiz giriniz.",
              },
            ]}
          >
            <PhoneInput
              inputStyle={{ width: "100%" }}
              country="tr"
              masks={{ tr: "(...) ...-..-.." }}
            />
          </Form.Item>
          <Form.Item
            label="Iban"
            name="iban"
            rules={[
              {
                required: true,
                message: "Lütfen Iban alanını boş bırakmayın.",
              },
            ]}
          >
            <Input
              type="text"
              onKeyDown={(evt) => evt.keyCode === 32 && evt.preventDefault()}
              defaultValue="TR"
              maxLength="26"
            />
          </Form.Item>
          <Row justify="space-between">
            <Col>
              <Button
                icon={<DownloadOutlined />}
                onClick={(() => setLoading(true), downloadExcelTemplate)}
                loading={loading}
              >
                Excel Şablonu İndir
              </Button>
              <Upload {...uploadExcelProps} fileList={fileList}>
                <Button icon={<UploadOutlined />}>Excel ile Ekle</Button>
              </Upload>
            </Col>
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Ekle
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};
export default EmployeeAddForm;
